import React from 'react';
/** Components Import */
import {
  BrowserMultiFormatReader,
  BarcodeFormat,
  DecodeHintType,
} from '@zxing/library';
import { Box, IconButton, Card, Tooltip } from '@mui/material';
import { Button } from '../../MUIs';
/** Icons Import */
import {
  NavigateBefore as BackIcon,
  Cameraswitch as CameraswitchIcon,
  Help as HelpIcon,
} from '@mui/icons-material';

function QrScanner({
  width = '300px',
  height = '70vh',
  tooltip = 'QR코드를 촬영을 위한 용도입니다.',
  backClick = () => {},
  getCode = (e) => {},
}) {
  const [localStream, setLocalStream] = React.useState('');
  const [cameraSwitch, setCarmeraSwitch] = React.useState(false);
  const Camera = React.useRef(null);
  const hints = new Map();
  const formats = [
    BarcodeFormat.QR_CODE,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.CODE_128,
    BarcodeFormat.CODABAR,
    BarcodeFormat.EAN_13,
    BarcodeFormat.EAN_8,
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_93,
  ];
  hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
  const Scan = new BrowserMultiFormatReader(hints, 500);
  let scanCount = 0;

  React.useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({
        video: { facingMode: 'user' }, //전면
        // video: { facingMode: { exact: 'environment' } }, //후면
      })
      .then((stream) => {
        setLocalStream(stream);
      })
      .catch((e) => {
        console.log(e);
        if (e) {
          window.alert('카메라 권한을 설정해주세요.');
        }
      });
    return () => {
      Stop();
    };
  }, []);

  React.useEffect(() => {
    if (!Camera.current) return;
    if (localStream && Camera.current) {
      Scanning();
    }
    return () => {
      Stop();
    };
  }, [localStream]);

  const Scanning = async () => {
    // const t = await Scan.decodeOnce();
    if (localStream && Camera.current) {
      try {
        const data = await Scan.decodeFromStream(
          localStream,
          Camera.current,
          (data, err) => {
            if (data) {
              getCode(data.getText());
              Scan.stopContinuousDecode();
              StopCamera(localStream);
            } else {
              // if (scanCount > 1000) {
              // 	Scan.stopContinuousDecode();
              // 	Stop();
              // } else {
              // scanCount++;
              getCode(false);
              // }
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  const Stop = () => {
    if (localStream) {
      const vidTrack = localStream.getVideoTracks();
      vidTrack.forEach((track) => {
        localStream.removeTrack(track);
      });
    }
  };

  const StopCamera = (stream) => {
    if (stream) {
      // 모든 비디오 트랙을 얻어서 종료
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <IconButton
          onClick={() => {
            scanCount = scanCount + 1001;
            Stop();
            backClick();
          }}
        >
          <BackIcon fontSize="large" />
        </IconButton>
        <Tooltip enterTouchDelay={50} leaveTouchDelay={50} title={tooltip}>
          <IconButton>
            <HelpIcon color="info" />
          </IconButton>
        </Tooltip>
        {/* <div style={{ width: "10%" }} /> */}
        {/* <IconButton onClick={() => setCarmeraSwitch(!cameraSwitch)}>
          <CameraswitchIcon fontSize="large" />
        </IconButton> */}
      </div>
      <Card sx={{ height: '65vh' }}>
        <div style={{ width: width, height: height }}>
          <video ref={Camera} id="video" />
        </div>
      </Card>
    </Box>
  );
}

export default QrScanner;
